import { render, staticRenderFns } from "./footLanguage.vue?vue&type=template&id=5aa0c464&scoped=true";
import script from "./footLanguage.vue?vue&type=script&lang=js";
export * from "./footLanguage.vue?vue&type=script&lang=js";
import style0 from "./footLanguage.vue?vue&type=style&index=0&id=5aa0c464&prod&lang=less&scoped=true";
import style1 from "./footLanguage.vue?vue&type=style&index=1&id=5aa0c464&prod&lang=less&scoped=true";
import style2 from "./footLanguage.vue?vue&type=style&index=2&id=5aa0c464&prod&lang=less";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "5aa0c464", null);
export default component.exports;